import { Action } from '@ngrx/store';
import { LoginResponse } from '@shared/models';
import { SessionState } from '@shared/services/session/session-state';
import { ContextTargetData, UserViewModel } from '@circlon/operate-api-model';

export enum ActionTypes {
  AUTH_LOGIN = '[Auth] Auth Login',
  AUTH_LOGIN_FROM_STORAGE = '[Auth] Auth login from storage',
  AUTH_LOGOUT = '[Auth] Auth Logout',
  AUTH_FAILURE = '[Auth] Auth Failure',
  AUTH_SUCCESS = '[Auth] Auth Success',
  AUTH_LOGIN_SUCCESS_FROM_STORAGE = '[Auth] Auth login success from storage',
  AUTH_LOGOUT_SUCCESS = '[Auth] Auth Logout Success',
  AUTH_REFRESH = '[Auth] Auth Refresh',
  AUTH_REFRESH_SINGLE = '[Auth] Single Auth Refresh',
  AUTH_REFRESH_SUCCESS = '[Auth] Auth Refresh Success',
  AUTH_REFRESH_FAILURE = '[Auth] Auth Refresh Failure',
  AUTH_EXPIRED_SHOW_LOGIN = '[Auth] Auth Expired show Login',
  AUTH_EXPIRED_LOGIN = '[Auth] Auth Expired Login',
  AUTH_EXPIRED_LOGIN_SUCCESS = '[Auth] Auth Expired Login Success',
  AUTH_EXPIRED_LOGIN_FAILURE = '[Auth] Auth Expired Login Failure',
  AUTH_EXPIRED_LOGIN_REROUTE_NEEDED = '[Auth] Auth Expired Reroute to auth pages needed',
  AUTH_REDIRECT = '[Auth] Auth Redirect',
  AUTH_REDIRECT_NOT_READY = '[Auth Api] Auth Redirect not ready',
  AUTH_EXPIRED_PASSWORD_CHANGED = '[Auth] User password expired',
}

export class AuthLoginAction implements Action {
  readonly type = ActionTypes.AUTH_LOGIN;

  constructor(public payload: { user: string; password: string }) {}
}

export class AuthLoginFromStorageAction implements Action {
  readonly type = ActionTypes.AUTH_LOGIN_FROM_STORAGE;
}

export class AuthFailureAction implements Action {
  readonly type = ActionTypes.AUTH_FAILURE;

  constructor(public payload: { error: any }) {}
}

export class AuthSuccessAction implements Action {
  readonly type = ActionTypes.AUTH_SUCCESS;

  constructor(
    public payload:
      { auth: LoginResponse,
        sessionState: SessionState
      }) {}
}

export class AuthLoginSuccessFromStorageAction implements Action {
  readonly type = ActionTypes.AUTH_LOGIN_SUCCESS_FROM_STORAGE;

  constructor(
    public payload:
      { auth: LoginResponse,
        user: UserViewModel,
        sessionState: SessionState,
        targets: ContextTargetData[],
        target?: ContextTargetData
      }) {}
}

export class AuthRefreshAction implements Action {
  readonly type = ActionTypes.AUTH_REFRESH;
}

export class AuthRefreshSingleAction implements Action {
  readonly type = ActionTypes.AUTH_REFRESH_SINGLE;
}

export class AuthRefreshSuccessAction implements Action {
  readonly type = ActionTypes.AUTH_REFRESH_SUCCESS;
  constructor(public payload: { auth?: LoginResponse }) {}
}

export class AuthRefreshFailureAction implements Action {
  readonly type = ActionTypes.AUTH_REFRESH_FAILURE;
}

export class AuthExpiredShowLoginAction implements Action {
  readonly type = ActionTypes.AUTH_EXPIRED_SHOW_LOGIN;
}

export class AuthExpiredLoginAction implements Action {
  readonly type = ActionTypes.AUTH_EXPIRED_LOGIN;

  constructor(public payload: { password: string }) {}
}

export class AuthExpiredLoginSuccessAction implements Action {
  readonly type = ActionTypes.AUTH_EXPIRED_LOGIN_SUCCESS;

  constructor(
    public payload: { auth: LoginResponse, sessionState: SessionState }
  ) {}
}

export class AuthExpiredLoginFailureAction implements Action {
  readonly type = ActionTypes.AUTH_EXPIRED_LOGIN_FAILURE;

  constructor(public payload: { error: any }) {}
}

export class AuthExpiredLoginRerouteToAuthAction implements Action {
  readonly type = ActionTypes.AUTH_EXPIRED_LOGIN_REROUTE_NEEDED;

  constructor(
    public payload: { auth?: LoginResponse, sessionState: SessionState }
  ) {}
}

export class AuthLogoutAction implements Action {
  readonly type = ActionTypes.AUTH_LOGOUT;
}

export class AuthLogoutSuccessAction implements Action {
  readonly type = ActionTypes.AUTH_LOGOUT_SUCCESS;
}

export class AuthRedirectAction implements Action {
  readonly type = ActionTypes.AUTH_REDIRECT;
}

export class AuthRedirectNotReadyAction implements Action {
  readonly type = ActionTypes.AUTH_REDIRECT_NOT_READY;
}

export class AuthExpiredPasswordChangedAction implements Action {
  readonly type = ActionTypes.AUTH_EXPIRED_PASSWORD_CHANGED;
}

export type Actions =
  AuthLoginAction
  | AuthLoginFromStorageAction
  | AuthFailureAction
  | AuthSuccessAction
  | AuthLoginSuccessFromStorageAction
  | AuthLogoutAction
  | AuthLogoutSuccessAction
  | AuthRefreshAction
  | AuthRefreshSuccessAction
  | AuthRefreshFailureAction
  | AuthRefreshSingleAction
  | AuthExpiredShowLoginAction
  | AuthExpiredLoginAction
  | AuthExpiredLoginSuccessAction
  | AuthExpiredLoginFailureAction
  | AuthExpiredLoginRerouteToAuthAction
  | AuthRedirectAction
  | AuthRedirectNotReadyAction
  | AuthExpiredPasswordChangedAction;
